<template>
  <modal :show.sync="showModal" header-classes="justify-content-center" @close="handleClose">
    <h4 slot="header" class="title title-up">
      Add New Discipleship Group
    </h4>
    <h2 v-if="error" style="color:red;">
      There was an error. Please refresh your page.
    </h2>
    <el-row>
      <label class="col-md-4 col-form-label">Discipleship Leader</label>
      <el-select
        class="col-md-8 select-default"
        filterable
        clearable
        v-model="newLeaderPersonId"
        placeholder="Select leader..."
      >
        <el-option
          v-for="item in addableLeaders"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-row>
    <br>
    <div style="margin-top: 20px;">
      <h4 class="card-title center">
        Participants
      </h4>
      <el-autocomplete
        v-model="queryAddParticipant"
        :fetch-suggestions="queryAddableParticipants"
        value-key="name"
        @select="handleSelectParticipant"
        id="searchAutocomplete-newgroup"
        style="width: 100%;"
      />
      <table class="table table-hover" v-show="selectedParticipants">
        <tbody>
          <tr
            v-for="participant in selectedParticipants"
            :key="participant.id"
          >
            <td style="width: 100%;">
              {{ participant.name }}
              <el-button
                @click="handleRemoveFromSelected(participant)"
                class="small"
              >
                <i class="el-icon-close" />
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      <span v-if="validationError.leader === true" style="color: red;">
        A leader is required.<br>
      </span>
    </p>
    <template slot="footer">
      <p-button @click.native="handleClose">
        Cancel
      </p-button>
      <p-button type="danger" v-if="!saving" @click.native="handleSave">
        Add
      </p-button>
      <p-button type="danger" v-if="saving">
        Adding...
      </p-button>
          &nbsp;&nbsp;
    </template>
  </modal>
</template>

<script>
import Modal from '../UIComponents/Modal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DiscipleshipGroupsRepository = RepositoryFactory.get('discipleshipGroups');

function validateLeader(newLeaderPersonId) {
    return !!newLeaderPersonId;
}

export default {
    name: 'AddDiscipleshipGroupModal',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false,
            material: '',
            validationError: {
                leader: false,
            },
            addableLeaders: [],
            queryAddParticipant: '',
            selectedParticipants: [],
            selectedParticipantsIds: [],
            unselectedParticipants: [],
            newLeaderPersonId: '',
            saving: false,
            error: false,
        };
    },
    props: {
        show: Boolean
    },
    computed: {
    },
    methods: {
        handleSave() {
            this.saving = true;
            this.validationError.leader = !validateLeader(this.newLeaderPersonId);
            if (this.validationError.leader) {
                this.saving = false;
                return;
            }
            this.selectedParticipants.forEach(this.addParticipantIds);
            DiscipleshipGroupsRepository.addDiscipleshipGroup(this.newLeaderPersonId, this.selectedParticipantsIds)
                .then((response) => {
                    this.saving = false;
                    this.handleClose();
                    this.$message(response.data.message);
                    this.$emit('save');
                    this.$emit('close');
                })
                .catch((error) => {
                    this.saving = false;
                    this.handleClose();
                    this.$message(error.response.data.message);
                    this.$emit('save');
                    this.$emit('close');
                });
        },
        handleClose() {
            this.newLeaderPersonId = '';
            this.newDiscipleType = '';
            this.queryAddParticipant = '';
            this.validationError.disciple = false;
            this.selectedParticipants = [];
            this.unselectedParticipants = [];
            this.selectedParticipantsIds = [];
            this.$emit('close');
        },
        handleRemoveFromSelected(participant) {
            this.unselectedParticipants.push(participant);
            this.selectedParticipants.splice(this.selectedParticipants.findIndex(
                (element) => element.id === participant.id
            ), 1);
        },
        handleSelectParticipant(participant) {
            this.queryAddParticipant = '';
            this.selectedParticipants.push(participant);
            this.unselectedParticipants.splice(this.unselectedParticipants.findIndex(
                (element) => element.id === participant.id
            ), 1);
        },
        getAddableLeadersList() {
            DiscipleshipGroupsRepository.getAddableLeadersList()
                .then((response) => {
                    this.addableLeaders = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        getAddableParticipantsList() {
            this.selectedParticipants = [];
            DiscipleshipGroupsRepository.getAddableParticipantsList()
                .then((response) => {
                    this.unselectedParticipants = response.data.data;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        queryAddableParticipants(queryString, callback) {
            if (queryString.length === 0) callback(this.unselectedParticipants);
            else {
                const results = queryString
                    ? this.unselectedParticipants.filter(
                        this.createParticipantsFilter(queryString)
                    ) : this.unselectedParticipants;
                callback(results);
            }
        },
        createParticipantsFilter(queryString) {
            return (participant) => participant.name.toLowerCase().includes(queryString.toLowerCase());
        },
        addParticipantIds(currentValue) {
            this.selectedParticipantsIds.push(currentValue.id);
        },
    },
    watch: {
        show(val) {
            this.showModal = val;
            if (this.showModal === true) {
                this.getAddableLeadersList();
                this.getAddableParticipantsList();
            }
        }
    },
    created() {
    },
    mounted() {
    }

};
</script>
